
import { useAuth } from "contexts/auth-context"
import { useEffect } from "react"
import GuestRoute from "routes/middleware/guest"
import Login from "./login"
import { lang } from "config"

const Logout = () => {
    const { logout } = useAuth()
    
    useEffect(() => {
        logout()
    }, [])

    return (
        <GuestRoute>
            <Login title={lang.title.sign_in} />
        </GuestRoute>
    )
}

export default Logout